import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Thread } from './elements';
import { Loader } from '../../../../common/elements';
import {
    getCurrentThread,
    getThreadPosts
} from '../../../../../actions/forums/forums';

class ThreadView extends Component {

    componentDidMount() {
        const { getCurrentThread, getThreadPosts } = this.props;
        const thread = this.props.params.threadId;
        getCurrentThread( thread );
        getThreadPosts( thread );
    };

    render() {

        const { thread, posts, params } = this.props;
        if( !thread || !posts ) {
            return <Loader  />;
        }
        return (
            <div className="col-xs-12" style={ { padding: '0 8em' } }>
                <Thread thread={ thread } posts={ posts } params={ params } />
            </div>
        );
    };
}

ThreadView.propTypes = {
    thread: PropTypes.object,
    posts: PropTypes.array,
    getCurrentThread: PropTypes.func,
    getThreadPosts: PropTypes.func
}

const mapStateToProps = ( state ) => {
    return {
        thread: state.forums.current_thread,
        posts: state.forums.posts,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        getCurrentThread: ( threadId ) => dispatch( getCurrentThread( threadId ) ),
        getThreadPosts: ( threadId ) => dispatch( getThreadPosts( threadId ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ThreadView );



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/ThreadView.js